import { connect } from 'react-redux';
import { IStyleProps } from '@cian/utils';
import {
  ECommuteDistanceType,
  EWcLocationType,
  IGetVillageListRequestSchema,
} from '../../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';

import {
  applyExtraFilters,
  changeAreaRange,
  changeBlackFridayTypeFilter,
  changeCommuteDistance,
  changeCommuteDistanceType,
  changeFinishDateFilter,
  changeFloorCountRange,
  changeHeatingSourceType,
  changeHouseMaterials,
  changeNewObjectTypesFilter,
  changeOtherCommunications,
  changePriceRangeFilter,
  changeReadyStatus,
  changeSaleStatuses,
  changeVillageClasses,
  changeWcLocationTypeFilter,
} from '../../../store/filters/actions';
import { clearFilters, onShowFiltersButton, showMobileFilters } from '../../../store/mobile/actions';
import { checkRegionInArray } from '../../../utils';
import { stringifyFilters } from '../../../utils/filters';
import { MobileFilters } from './index';
import { fetchRegions } from '../../../store/geo/thunkActions';
import { ChangeEvent } from 'react';

interface IMobileFiltersStoreProps {
  areFiltersOpened?: boolean;
  showClearButton?: boolean;
  showRoadFilters?: boolean;
  filters: IGetVillageListRequestSchema;
  showBlackFridayFilter?: boolean;
}

export interface IMobileFiltersDispatchProps {
  applyFilters(): void;
  clearFilters(): void;
  changeAreaRange(min?: number, max?: number): void;
  changeCommuteDistance(min?: number, max?: number): void;
  changeCommuteDistanceType(value: string): void;
  changeNewObjectTypes(value: string[]): void;
  changeVillageClasses(value: string[]): void;
  changeFinishDate(value: string): void;
  changeFloorCountRange(min?: number, max?: number): void;
  changeHeatingSourceType(value: string[]): void;
  changeHouseMaterials(value: string[]): void;
  changeOtherCommunications(value: string[]): void;
  changePriceRangeFilter(min?: number, max?: number): void;
  changeSaleStatus(value: string[]): void;
  changeReadyStatus(value: string[]): void;
  changeWcLocationType(value: string | undefined): void;
  fetchRegions(): void;
  showMobileFilters(value: boolean): void;
  onShowFiltersButton(): void;
  changeBlackFridayFilter(event: ChangeEvent<HTMLInputElement>, value?: boolean): void;
}

type IMobileFiltersOwnProps = IStyleProps;

export function mapStateToProps(state: IApplicationState): IMobileFiltersStoreProps {
  const {
    filters,
    geo: { currentRegion, selectedRegion },
    mobile: { areFiltersOpened },
    roads: { regions },
    blackFridaySettings: { isActive, url },
  } = state;

  const shouldIgnoreLocation =
    filters.locationId === filters.regionId && currentRegion && currentRegion.id === filters.regionId;

  return {
    areFiltersOpened,
    filters,
    showClearButton: !!stringifyFilters({
      ...filters,
      locationId: shouldIgnoreLocation ? undefined : filters.locationId,
      locationType: shouldIgnoreLocation ? undefined : filters.locationType,
    }),
    showRoadFilters: checkRegionInArray(selectedRegion || currentRegion, regions),
    showBlackFridayFilter: isActive && !!url,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IMobileFiltersDispatchProps {
  return {
    applyFilters: () => dispatch(applyExtraFilters(true)),
    clearFilters: () => dispatch(clearFilters()),
    changeAreaRange: (min, max) => dispatch(changeAreaRange(min, max)),
    changeCommuteDistance: (min, max) => dispatch(changeCommuteDistance({ min, max })),
    changeCommuteDistanceType: value => dispatch(changeCommuteDistanceType(value as ECommuteDistanceType)),
    changeNewObjectTypes: value => dispatch(changeNewObjectTypesFilter(value)),
    changeFinishDate: value => dispatch(changeFinishDateFilter(value)),
    changeFloorCountRange: (min, max) => dispatch(changeFloorCountRange(min, max)),
    changeHeatingSourceType: value => dispatch(changeHeatingSourceType(value)),
    changeHouseMaterials: value => dispatch(changeHouseMaterials(value)),
    changeOtherCommunications: value => dispatch(changeOtherCommunications(value)),
    changePriceRangeFilter: (min, max) => dispatch(changePriceRangeFilter({ min, max })),
    changeReadyStatus: value => dispatch(changeReadyStatus(value)),
    changeSaleStatus: value => dispatch(changeSaleStatuses(value)),
    changeVillageClasses: value => dispatch(changeVillageClasses(value)),
    fetchRegions: () => dispatch(fetchRegions()),
    showMobileFilters: value => dispatch(showMobileFilters(value)),
    changeWcLocationType: value => dispatch(changeWcLocationTypeFilter(value as EWcLocationType)),
    onShowFiltersButton: () => dispatch(onShowFiltersButton()),
    changeBlackFridayFilter: (_, value) => dispatch(changeBlackFridayTypeFilter(value || undefined)),
  };
}

export type TMobileFiltersProps = IMobileFiltersStoreProps & IMobileFiltersDispatchProps & IMobileFiltersOwnProps;

export const MobileFiltersContainer = connect<IMobileFiltersStoreProps, IMobileFiltersDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(MobileFilters);
